import { useAccountIdContext } from '../AccountIdContext';
import React from 'react';
import { useRefreshAlternateMinimumDueArrangements, useRequestAlternateMinimumDue } from '@app/sdk';
import { FormProvider, useForm } from 'react-hook-form';
import { FormContainer, Input } from '@app/shared';

export function RequestAlternativeMinDueForm() {
  const { accountId } = useAccountIdContext();
  const { mutateAsync: requestAlternateMinimumDue, isPending: isRequestingAlternateMinimumDue } =
    useRequestAlternateMinimumDue();

  const refreshAlternateMinimumDueArrangements = useRefreshAlternateMinimumDueArrangements();

  async function onRequestAlternateMinimumDue(data: {
    alternateDueAmount: number;
    alternateDueStartDate: string;
    alternateDueEndDate: string;
  }) {
    await requestAlternateMinimumDue({
      accountId: accountId,
      amount: data.alternateDueAmount,
      startDate: data.alternateDueStartDate,
      endDate: data.alternateDueEndDate,
    });
    setTimeout(() => {
      refreshAlternateMinimumDueArrangements();
    }, 2000);
  }

  const formContext = useForm<{
    alternateDueAmount: number;
    alternateDueStartDate: string;
    alternateDueEndDate: string;
  }>();
  return (
    <>
      <div className="ui basic segment">
        <div className="ui basic segment">
          <h3 className="ui left floated header">Request Alternate Minimum Due</h3>
        </div>
        <div className="ui basic segment">
          <FormProvider {...formContext}>
            <FormContainer isSubmitting={isRequestingAlternateMinimumDue} onSubmit={onRequestAlternateMinimumDue}>
              <Input defaultValue={''} name={'alternateDueAmount'} label={'Amount:'} />
              <Input
                defaultValue={''}
                name={'alternateDueStartDate'}
                label={'Start Date:'}
                placeholder={'Optional: yyyy-mm-dd'}
              />
              <Input
                defaultValue={''}
                name={'alternateDueEndDate'}
                label={'End Date:'}
                placeholder={'Optional yyyy-mm-dd'}
              />
            </FormContainer>
          </FormProvider>
        </div>
      </div>
    </>
  );
}
